const canUseWindow = typeof window !== 'undefined';
const DEV_MODE = canUseWindow && window.location.href.indexOf("localhost:8000") !== -1;

const setNewLocation = (newLocation) => {
  canUseWindow && (window.location = newLocation);
};

const windowOpen = (newLocation) => {
  canUseWindow && (window.open(newLocation));
};

const getWindowHref = () => {
  return canUseWindow ? window.location.href : ""
};

const getLocationHash = () => {
  return canUseWindow && window.location.hash.substring(1);
};

const isMobileOrTablet = () => {
  if (canUseWindow && !WURFL) return true; // play it safe

  return canUseWindow && WURFL && WURFL.is_mobile;
};

const getGoogleApi = () => {
  return canUseWindow && window.gapi;
};

const localStorageSet = (key, value) => {
  canUseWindow && localStorage.setItem(key, value);
};

const localStorageGet = (key) => {
  return canUseWindow && localStorage.getItem(key);
};

export {
  setNewLocation,
  windowOpen,
  getWindowHref,
  getLocationHash,
  getGoogleApi,
  isMobileOrTablet,
  localStorageSet,
  localStorageGet,
  canUseWindow,
  DEV_MODE
}



// WEBPACK FOOTER //
// ./src/lib/window.js